import { Modal } from 'react-bootstrap'
import styles from './WarningModalHeader.module.scss'
import { ModalHeaderProps } from 'react-bootstrap/ModalHeader'
import classNames from 'classnames'

export const WarningModalHeader = (props: ModalHeaderProps) => (
  <Modal.Header
    closeButton
    {...props}
    className={classNames(
      `${styles.warningModalHeader} d-flex align-items-center`,
      props.className
    )}
    ref={undefined}
  />
)
